import { render, staticRenderFns } from "./CardGestionVotantes.vue?vue&type=template&id=caeb2122"
import script from "./CardGestionVotantes.vue?vue&type=script&lang=js"
export * from "./CardGestionVotantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports